import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("f09202d0de", "@layer wp-ui{@layer utilities, components, compositions, overrides;@layer components{.dab08383b2254885__input-wrapper{padding:var(--wpds-dimension-padding-sm,8px) var(--wpds-dimension-padding-sm,8px) var(--wpds-dimension-padding-xs,4px)}}}");
}
export default {"input-wrapper":"dab08383b2254885__input-wrapper"};
